import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  useToast,
} from '@ais-ui/ui-core';
import React from 'react';
import { CustomizePopover } from './CustomizePopover';
import { passagelineReportMiscellaneous } from '../reportsTypes';
import {
  ParsedReportParams,
  usePassagelineReconfigure,
} from '@ais-ui/websockets';
import { useFetchOverlayData } from '../useMapReportOverlay';
import { markErrorHandledLocally } from '@ais-ui/custom-hooks';

interface CustomizePassagelineProps {
  report: ParsedReportParams;
  className?: string;
}

export const CustomizePassageline = ({
  report,
  className,
}: CustomizePassagelineProps) => {
  const fetchOverlayData = useFetchOverlayData();
  const { mutate } = usePassagelineReconfigure(fetchOverlayData);

  const [outputType, setOutputType] = React.useState(report.params.TYP);
  const { toast } = useToast();

  const onApply = () => {
    mutate(
      {
        jobId: report.info?.['Job ID'] as string,
        outputType: outputType,
      },
      {
        onSuccess: () => {
          toast({
            title: 'Success!',
            description: 'Customized passageline report successfully',
          });
        },
        onError: (error) => {
          markErrorHandledLocally(error);
          toast({
            title: 'Error!',
            description: 'Error customizing passageline report',
            variant: 'destructive',
          });
        },
      },
    );
  };

  return (
    <CustomizePopover>
      <form className="grid grid-cols-2 gap-8 p-2 w-96">
        <div className="space-y-2">
          <Label htmlFor="output-type">Output type</Label>
          <Select value={outputType} onValueChange={setOutputType}>
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select an output type" />
            </SelectTrigger>
            <SelectContent>
              {passagelineReportMiscellaneous?.outputType?.options?.map(
                (outputTypeOption) => (
                  <SelectItem
                    key={outputTypeOption.value}
                    value={outputTypeOption.value}
                  >
                    {outputTypeOption.label}
                  </SelectItem>
                ),
              )}
            </SelectContent>
          </Select>
        </div>
      </form>
      <div className="pt-6 flex justify-end">
        <Button onClick={onApply}>Apply</Button>
      </div>
    </CustomizePopover>
  );
};
